import { useClubData } from '../lib/club-data.context';

// Map of common club names to their refdata IDs
// This helps us convert club names to IDs for the API
const CLUB_ID_MAP: Record<string, string> = {
  'manchester united': '985',
  'chelsea': '631',
  'arsenal': '11',
  'liverpool': '31',
  'manchester city': '281',
  'tottenham': '148',
  'everton': '29',
  'newcastle': '762',
  'west ham': '379',
  'aston villa': '405',
  'leeds': '399',
  'southampton': '180',
  'crystal palace': '873',
  'leicester': '289',
  'wolves': '543',
  'brighton': '1237',
  'burnley': '1132',
  'watford': '1010',
  'norwich': '1123',
  'brentford': '1148'
};

/**
 * Hook to fetch news for a club
 * Uses the ClubDataContext to access centralized news data
 * @param clubNameOrId - Optional override for club name or ID (if not provided, uses user's club)
 * @returns News items, loading state, and error state
 */
export const useNews = (clubNameOrId?: string) => {
  // If no specific club is requested, use the centralized data
  if (!clubNameOrId) {
    const { clubNews, isLoading, error } = useClubData();
    return { news: clubNews, isLoading, error };
  }
  
  // If a specific club is requested, we still use the old implementation
  // This is for backward compatibility with components that specify a club
  const { clubNews, isLoading, error } = useClubData();
  
  // For now, just return the user's club news
  // In a real implementation, we would fetch the specific club's news
  return { news: clubNews, isLoading, error };
};